
import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size, Rectangle, Vector, DraggingOffsets } from "../../../../../base/domain/drawing";
import { IFormatObjectEditable } from "../../../../domain/editableFormat";
import { default as FormatPageStructureEditableMixin } from "./FormatPageStructureEditableMixin.vue";
import { default as CommonComponentsAccessibleMixin } from "./CommonComponentsAccessibleMixin.vue";

@Component
export default class FormatPageObjectEditableMixin extends Mixins(FormatPageStructureEditableMixin, CommonComponentsAccessibleMixin) {
  @Prop()
  index: number;

  @Prop({ default: 1 })
  scale: number;

  get object(): IFormatObjectEditable {
    return this.objects[this.index];
  }

  set object(value: IFormatObjectEditable) {
    this.writePropertyWhenValid(s => s.updateObject(value));
  }

  get overview(): string {
    return this.object.getOverview();
  }

  get offsets(): DraggingOffsets<IFormatObjectEditable> {
    return this.readPropertyOrDefault(
      s => DraggingOffsets.from(s.getOffsets()),
      new DraggingOffsets(null, new Point(0, 0), new Rectangle(new Point(1, 1), new Size(1, 1)), new Vector(new Point(0, 0), new Point(0, 0))));
  }
}
